<template>
  <div
    class="image-lightbox"
    :class="{ active: visible }"
    @click="close"
  >
    <button class="image-lightbox-close" @click.stop="close" title="关闭"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
    <img :src="imageUrl" alt="" @click.stop>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'

const props = defineProps<{ visible: boolean; imageUrl: string }>()
const emit = defineEmits<{ close: [] }>()

function close() {
  emit('close')
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') close()
}

watch(() => props.visible, (v) => {
  if (v) {
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKeydown)
  } else {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', onKeydown)
  }
})
</script>
